import React, { useEffect } from "react";
//images
import information from "./assets/information.png";
import { Container, MessageStatus } from "./styles";

const ChatText = React.forwardRef((props, ref) => {
    useEffect(() => {});

    return (
        <>
            {props.status === "invisible" && (
                <MessageStatus id="info-status">
                    <img src={information} alt="icon-status" />
                    This contact is offline.
                </MessageStatus>
            )}
            {props.status === "busy" && (
                <MessageStatus id="info-status">
                    <img src={information} alt="icon-status" />
                    This contact is busy and may not respond.
                </MessageStatus>
            )}
            {props.status === "away" && (
                <MessageStatus id="info-status">
                    <img src={information} alt="icon-status" />
                    This contact is away and may not respond.
                </MessageStatus>
            )}
            <Container className="div-messages-text" id={props.socketidperson} ref={ref}>
                {props.children}
            </Container>
        </>
    );
});

export default ChatText;
